"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// ExportButtonComponent.tsx
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const ExportDataComponent_1 = require("../Popups/ExportDataComponent");
const S = __importStar(require("./SessionsListView.style"));
const ExportButtonComponent = ({ NO_SESSIONS, EXCEEDS_LIMIT, sessionsIds, showExportPopup, handleExportClick, exportButtonRef, }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    if (NO_SESSIONS || EXCEEDS_LIMIT) {
        return (react_1.default.createElement("div", { ref: exportButtonRef },
            react_1.default.createElement(S.ExportSessionsButton, { onClick: handleExportClick, "$hasSessions": false }, t("map.exportButton"))));
    }
    else {
        return (react_1.default.createElement(ExportDataComponent_1.ExportDataComponent, { button: react_1.default.createElement(S.ExportSessionsButton, { "$hasSessions": true }, t("map.exportButton")), sessionsIds: sessionsIds, isIconOnly: true, onSubmit: (formData) => { }, fixedSessionTypeSelected: true, isSessionList: true, open: showExportPopup }));
    }
};
exports.default = ExportButtonComponent;
